import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { injectIntl } from 'react-intl'
import _ from 'lodash'
import { Box, Col, ModalContent, RfButton, Row, Typography } from '@vibialighting/ui-kit'

import { useModalContext } from '@/contexts/ModalContext'
import errorActions from '@/redux/actions/error.actions'

const error = (props) => {
	const {
		intl: { formatMessage }
	} = props

	const { modalUnmount } = useModalContext()
	const dispatch = useDispatch()

	const error = useSelector(state => state.error, shallowEqual)

	const handleClose = () => {
		dispatch(errorActions.clearError())
		modalUnmount()
	}

	return (
		<ModalContent noPadding>
			<Box padding={6}>
				{error.details?.response ? (
					<>
						<Typography variant="h5" gutterBottom>
							{formatMessage({
								id: `error.${error.action}.${error.details.response.status}.title`,
								defaultMessage: formatMessage({
									id: `error.${error.action}.title`,
									defaultMessage: formatMessage({
										id: `error.${error.details.response.status}.title`,
										defaultMessage: formatMessage({ id: 'error.title' })
									})
								})
							})}
						</Typography>
						<Typography gutterBottom>
							{formatMessage({
								id: `error.${error.action}.${error.details.response.status}.msg`,
								defaultMessage: formatMessage({
									id: `error.${error.action}.msg`,
									defaultMessage: formatMessage({
										id: `error.${error.details.response.status}.msg`,
										defaultMessage: formatMessage({ id: 'error.msg' })	
									})
								})
							})}
						</Typography>
						{console.info(`error.${error.action}.${error.details.response.status}`, error)}
					</>
				) : (
					<>
						<Typography variant="h5">{formatMessage({ id: 'error.title' })}</Typography>	
						<Typography gutterBottom>
							{formatMessage({ id: 'error.msg' })}
						</Typography>
						<Typography gutterBottom>
							{error.details?.message || error.error?.message}
						</Typography>
					</>
				)}
				<Typography>{formatMessage({ id: 'error.contactUs' })}</Typography>
			</Box>
			<Box paddingX={6} paddingBottom={6} paddingTop={3}>
				<Row justifyContent="end">
					<Col width="auto">
						<RfButton variant="ghost" color="error" onClick={handleClose}>{formatMessage({ id: 'error.close' })}</RfButton>
					</Col>
				</Row>
			</Box>
		</ModalContent>
	)
}

export default injectIntl(error)
